/**
 * Enum Ngừng theo dõi
 * NVTUAN1 07.07.2022
 */
export default {
  All: -1,
  Follow: 0,
  Unfollow: 1,
};
